import {
  BannerRenderRequest,
  FloorAdRenderRequest,
  PlatformType,
} from '@shared/Ads/Yandex/types';

export type AdvManager = {
  render: (
    props: FloorAdRenderRequest | BannerRenderRequest,
    renderFallback: (() => void) | undefined,
  ) => void;
  getPlatform: () => PlatformType;
};

export const getAdvManager = (): AdvManager =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).Ya.Context.AdvManager;
